"use strict";

exports.movieTypesHash = {
  performance: 'performance',
  movie: 'movie',
  lecture: 'lecture',
  concert: 'concert',
  broadcast: 'broadcast'
};
exports.movieTypeTitlesHash = {
  performance: 'Спектакль',
  movie: 'Фильм',
  lecture: 'Лекция',
  concert: 'Концерт',
  broadcast: 'Трансляция'
};
exports.movieTypePluralTitlesHash = {
  performance: 'Спектакли',
  movie: 'Фильмы',
  lecture: 'Лекции',
  concert: 'Концерты',
  broadcast: 'Трансляции'
};
exports.movieTypeGenderHash = {
  performance: 'male',
  movie: 'male',
  lecture: 'female',
  concert: 'male',
  broadcast: 'female'
};
exports.schoolClassesHash = {
  5: '5',
  6: '6',
  7: '7',
  8: '8',
  9: '9',
  10: '10',
  11: '11',
  after: 'После окончания школы'
};